import React, { Component } from 'react';
import {Link, withRouter } from 'react-router-dom';

import "./style/PanelLink.css"

const PanelLink = function (props) {

    return (
        <Link to={props.path} className="panelLink">
            {props.children}
        </Link>
    )

}

export default withRouter(PanelLink);